import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';

export default class TicketNotesModal extends Modal {
  static isDismissibleViaBackdropClick = false;

  oninit(vnode) {
    super.oninit(vnode);

    this.note = Stream(this.attrs.ticket.privateNote() || '');
  }

  className() {
    return 'Modal--large Support-Modal';
  }

  title() {
    return app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">{this.fields().toArray()}</div>
      </div>
    );
  }

  fields() {
    const items = new ItemList();

    items.add(
      'name',
      <div className="Form-group">
        <label>{app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.title')}</label>
        <div style={{ marginBottom: '15px' }}>{app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.info')}</div>
        <textarea
          className="FormControl"
          placeholder={app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.placeholder')}
          bidi={this.note}
          style={{
            width: '100%',
            maxWidth: '100%',
            minHeight: '250px',
          }}
        />
        <div style={{ marginTop: '10px', fontSize: '12px' }}>
          {app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.tip')}
        </div>
      </div>,
      50
    );

    items.add(
      'submit',
      <div className="Form-group">
        {Button.component(
          {
            type: 'submit',
            className: 'Button Button--primary SupportModal-save',
            loading: this.loading,
          },
          'Update'
        )}
      </div>,
      -10
    );

    return items;
  }

  submitData() {
    return {
      privateNote: this.note(),
    };
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    this.attrs.ticket.save(this.submitData()).then(
      () => {
        this.hide();
      },
      (response) => {
        this.loading = false;
        this.handleErrors(response);
      }
    );
  }
}
